import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

export const useHeaderTabStyles = makeStyles(() =>
  createStyles({
    tabPanelRoot: {
      '&:not([hidden])': {
        display: 'flex',
      },
      flexDirection: 'column',
    },
  })
);
